<template>
  <el-form-item label="留学时间" label-width="80px">
    <el-input
      v-model="abroadTime"
      suffix-icon="el-icon-date"
      placeholder="选择月份"
      @focus="abroadTimeDialog2=true;"
    ></el-input>
    <el-dialog title="选择留学时间" :visible.sync="abroadTimeDialog2" :modal="false">
      <el-form>
        <el-row :span="20">
          <el-col :span="10">
            <el-form-item label="年份" prop="year">
              <el-select v-model="query.year" placeholder="请选择年份" filterable style="width:100%;">
                <el-option v-for="item in yearList" :label="item+'年'" :value="item" :key="item"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="月份" prop="month">
              <el-select v-model="query.month" placeholder="请选月份" filterable style="width:100%;">
                <el-option v-for="item in [1,4,7,10]" :label="item+'月'" :value="item" :key="item"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="yesClick();">确 定</el-button>
        <el-button
          type="info"
          @click="abroadTimeDialog2 = false;abroadTime='';$emit('selabroad',abroadTime);"
        >清 空</el-button>
      </span>
    </el-dialog>
  </el-form-item>
</template>


<script>
import dateHelper from "@/plugins/dateHelper.js";
//留学时间选择
export default {
  props: {
    time: String,
    yearMode: {
      type: String,
      default: "default" // default: 当前年~当前年+5；vipStu: 2017~当前年+5
    },
    minYear: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      abroadTimeDialog2: false,
      abroadTime: "",
      query: {},
      yearList: []
    };
  },
  methods: {
    //确定按钮时间
    yesClick() {
      this.abroadTimeDialog2 = false;
      var query = this.query;
      if (query.year) {
        if (query.month) {
          this.abroadTime = query.year + "-" + query.month;
          this.$emit("selabroad", this.abroadTime);
        }
      }
    },
    // 设置留学时间
  setAbroadTime(time) {
    this.abroadTime = time || ""; // 如果传入的时间为空，则设置为空字符串
    // if(time){
    //   this.query.year = time.split('-')[0];
    //   this.query.month = time.split('-')[1];
    // }
  }
  },
  mounted() {
    //申请年份
    var years = [];
    if (this.yearMode === "vipStu") {
      var start = 2017;
      var end = new Date().getFullYear() + 5;
      for (var y = start; y <= end; y++) {
        years.push(y);
      }
    } else {
      years = dateHelper.getYearList();
    }
    if (this.minYear) {
      years = years.filter(y => Number(y) >= Number(this.minYear));
    }
    this.yearList = years;
  }
};
</script>
